import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { fetchAuthSession, fetchMFAPreference, fetchUserAttributes, getCurrentUser } from 'aws-amplify/auth';

const toPreferredMFA = preferred => {
  switch (preferred) {
    case 'SMS':
      return 'SMS_MFA';

    case 'TOTP':
      return 'TOTP';

    default:
      return 'NOMFA';
  }
};

const parseUserAttributes = attributes => {
  var _attributes$id, _attributes$email, _attributes$phone_num, _attributes$create_da;

  return { ...attributes,
    id: (_attributes$id = attributes.id) !== null && _attributes$id !== void 0 ? _attributes$id : '',
    email: (_attributes$email = attributes.email) !== null && _attributes$email !== void 0 ? _attributes$email : '',
    phone_number: (_attributes$phone_num = attributes.phone_number) !== null && _attributes$phone_num !== void 0 ? _attributes$phone_num : '',
    email_verified: attributes.email_verified === 'true',
    phone_number_verified: attributes.phone_number_verified === 'true',
    create_date: (_attributes$create_da = attributes.create_date) !== null && _attributes$create_da !== void 0 ? _attributes$create_da : ''
  };
};

export const fetchAuthUser = function () {
  var _ref = _asyncToGenerator(function* () {
    const {
      username,
      userId
    } = yield getCurrentUser();
    const [rawAttributes, mfaPreference] = yield Promise.all([fetchUserAttributes(), fetchMFAPreference().catch(() => ({}))]);
    let attributes = parseUserAttributes(rawAttributes);

    if (Object.keys(rawAttributes).length === 0) {
      var _tokens$idToken$paylo, _tokens$idToken;

      const {
        tokens
      } = yield fetchAuthSession();
      const payload = (_tokens$idToken$paylo = tokens === null || tokens === void 0 ? void 0 : (_tokens$idToken = tokens.idToken) === null || _tokens$idToken === void 0 ? void 0 : _tokens$idToken.payload) !== null && _tokens$idToken$paylo !== void 0 ? _tokens$idToken$paylo : {};
      attributes = parseUserAttributes(Object.fromEntries(Object.entries(payload).map(([key, claim]) => [key, claim === null || claim === void 0 ? void 0 : claim.toString()])));
    }

    return {
      username,
      userId,
      attributes,
      preferredMFA: toPreferredMFA(mfaPreference.preferred)
    };
  });

  return function fetchAuthUser() {
    return _ref.apply(this, arguments);
  };
}();